var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('section',{staticClass:"drawer"},[_c('DrawerCover',{attrs:{"model":_vm.data}}),_c('DrawerSampleList',{attrs:{"samples":_vm.samples}}),(_vm.samples)?_c('DrawerFooter',{attrs:{"numItems":_vm.samples.length}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }